export enum SquareIntent {
    CHARGE = 'CHARGE',
    STORE = 'STORE',
}
